export default "__VITE_ASSET__Bu6Wh9M5__"